import { useEffect } from "react";

import { env } from "~/env";
import { useStoreViewPageActivity } from "~/hooks";
import { ROUTES } from "~/router";
import { usePageTitle } from "~/shared";
import HighlightedText from "~/ui/common/HighlightedText";
import { PersonalSettings } from "./components";

export const Profile = () => {
  usePageTitle("Account Settings");

  const { mutate } = useStoreViewPageActivity();

  useEffect(() => {
    mutate(ROUTES.hubProfile);
  }, []);

  return (
    <div className="md:max-w-3xl">
      <div className="flex flex-col md:max-w-2xl">
        <h1 className="font-ivy text-indigo pb-8 text-4xl font-light">
          Account <HighlightedText>Settings</HighlightedText>
        </h1>

        <div className="mb-4 space-y-3">
          <h2 className="font-ivy text-indigo text-2xl font-normal md:pt-3">
            Display name
          </h2>
          <p className="text-midnight-indigo text-sm">
            Adjust your name as it’s displayed in the private community.
          </p>
        </div>

        <PersonalSettings className="border-b-vivid-blue-purple max-w-2xl border-b pb-8" />

        <div className="text-midnight-indigo mt-6 text-sm">
          Need to make changes to your email, phone number, or other account
          information? Contact us at{" "}
          <a
            href={`tel:+1${env.VITE_SUPPORT_PHONE_NUMBER}`}
            className="text-violet"
          >
            {env.VITE_SUPPORT_PHONE_NUMBER}
          </a>{" "}
          or{" "}
          <a
            href={`mailto:${env.VITE_ELEKTRA_CARE_EMAIL}`}
            className="text-violet"
          >
            {env.VITE_ELEKTRA_CARE_EMAIL}
          </a>
        </div>
      </div>
    </div>
  );
};
